import { Box } from '@mui/material'

const BARS = [
  { height: 9, opacity: 0.65 },
  { height: 14, opacity: 1 },
  { height: 20, opacity: 1 },
  { height: 12, opacity: 0.65 },
]

const BASE_SIZE = 38

const LogoCircle = ({ size = BASE_SIZE }: { size?: number }) => {
  const scale = size / BASE_SIZE

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'linear-gradient(135deg,#1d506b,#133649)',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        gap: `${2 * scale}px`,
        padding: `${9 * scale}px`,
        flexShrink: 0,
      }}
    >
      {BARS.map(({ height, opacity }, index) => (
        <Box
          key={index}
          sx={{
            width: 4 * scale,
            height: height * scale,
            background: '#fff',
            borderRadius: `${1.5 * scale}px`,
            opacity,
          }}
        />
      ))}
    </Box>
  )
}

export default LogoCircle
